export default "__VITE_ASSET__CvVqUMht__"